var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2",
    "data-name": "Group 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 171.648,
    height: 65.05,
    viewBox: "0 0 171.648 65.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 171.648,
    height: 65.05,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M3.016,207.64a10.377,10.377,0,0,1,7.381-2.875,10.269,10.269,0,0,1,7.31,2.839,9.2,9.2,0,0,1,2.981,6.991,9.412,9.412,0,0,1-3.016,7.133,10.414,10.414,0,0,1-7.346,2.839,10.266,10.266,0,0,1-7.346-2.8,9.815,9.815,0,0,1,.036-14.124m4.01,10.5a4.578,4.578,0,0,0,3.336,1.348,4.608,4.608,0,0,0,4.649-4.862,4.709,4.709,0,0,0-1.348-3.442,4.472,4.472,0,0,0-3.336-1.384,4.394,4.394,0,0,0-3.3,1.384,4.708,4.708,0,0,0-1.349,3.442,4.875,4.875,0,0,0,1.349,3.513",
    transform: "translate(0 -181.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M196.623,208.081h.071a6.71,6.71,0,0,1,5.784-2.7,8.08,8.08,0,0,1,6.494,2.981,10.317,10.317,0,0,1,2.52,6.814,10.211,10.211,0,0,1-2.591,6.885,8.32,8.32,0,0,1-6.565,2.981,6.89,6.89,0,0,1-5.607-2.449h-.071v6.341h-5.536v-23.2h4.349Zm1.242,10.611a4.8,4.8,0,0,0,6.672,0,4.875,4.875,0,0,0,1.349-3.513,4.668,4.668,0,0,0-4.72-4.791,4.5,4.5,0,0,0-3.3,1.348,4.709,4.709,0,0,0-1.349,3.442,4.876,4.876,0,0,0,1.349,3.513",
    transform: "translate(-169.143 -181.765)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M383.873,215.919a4.447,4.447,0,0,0,4.684,3.726,5.074,5.074,0,0,0,4.223-2.271l4.01,2.626c-1.6,2.875-4.294,4.294-8.162,4.294a10.564,10.564,0,0,1-7.417-2.768,9.425,9.425,0,0,1-2.981-7.169,9.522,9.522,0,0,1,2.945-6.991,9.783,9.783,0,0,1,7.1-2.91,9.007,9.007,0,0,1,9.44,9.475c0,.887-.036,1.561-.071,1.987Zm8.3-3.655a3.744,3.744,0,0,0-4.045-3.3,4.221,4.221,0,0,0-4.117,3.3Z",
    transform: "translate(-334.734 -180.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M573.457,224.688v-10.5c0-2.236-1.136-3.691-3.3-3.691-2.236,0-3.407,1.6-3.407,3.691v10.5h-5.536v-18.95h4.349l1.152,2.484h.035a4.946,4.946,0,0,1,1.881-1.845,6.169,6.169,0,0,1,3.478-.993,6.072,6.072,0,0,1,5.11,2.165,8.239,8.239,0,0,1,1.739,5.359v11.782Z",
    transform: "translate(-496.674 -181.764)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 1.905,
    height: 65.05,
    transform: "translate(88.539)",
    fill: "#1718ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M1255.028,156.8a14.493,14.493,0,1,0,14.493,14.493,14.493,14.493,0,0,0-14.493-14.493m0,21.955a7.462,7.462,0,1,1,7.463-7.462,7.462,7.462,0,0,1-7.463,7.462",
    transform: "translate(-1097.873 -138.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M1039.733,156.882a17,17,0,0,1,5.9,6.345h5.08V185.7h6.983l-.011-22.471h5.081a17,17,0,0,1,5.9-6.345Z",
    transform: "translate(-920.163 -138.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M859.865,174.332a7.462,7.462,0,1,1,0-6.083h7.358a14.493,14.493,0,1,0,0,6.083Z",
    transform: "translate(-742.123 -138.766)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.ab7dcf916d34b0e632209888a275ed3b.svg";
export { ForwardRef as ReactComponent };